import { formatInTimeZone } from 'date-fns-tz/formatInTimeZone'
import { format } from 'date-fns/format'
import { isValid } from 'date-fns/isValid'
import { parseISO } from 'date-fns/parseISO'

import { parseServiceDate } from '../MenuHeader/ServiceSelectionGraphql/serviceWeeks'

export function formatOrderDatePayload(value: string, timezone?: string | null): string {
  const date = timezone ? parseServiceDate(value, timezone) : parseISO(value)
  if (!isValid(date)) return 'Invalid date'
  // Local Moment values keep +00:00 even when the browser is in UTC.
  if (!timezone) return format(date, "yyyy-MM-dd'T'HH:mm:ssxxx")
  // Read zoned fields directly. An intermediate browser-local Date can normalize
  // a location's midnight through the browser's own DST gap.
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date)
  const field = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value
  const offset = formatInTimeZone(date, timezone, 'XXX')
  return `${field('year')}-${field('month')}-${field('day')}T${field('hour')}:${field('minute')}:${field('second')}${offset}`
}
